import { mapAisVersion } from './entityMappers';

export const mapFetchAisVersionListResponse = (data) => {
  return (data || []).map(mapAisVersion);
};
